import React, {useMemo, useState, useEffect} from "react";
import { Trans, useTranslation } from "react-i18next";
import "./style.less";

import { useForm } from "react-hook-form";
import { userServices } from "../../../../services";

import CountryAndPhoneSelect from "../../../../components/CountryAndPhoneSelect";
import useQuery from "../../../../utils/query";
import {useAuth} from "../../../../services/authServices";

import EmailIcon from "../../../../components/svg/Email";
import PhoneIcon from "../../../../components/svg/Phone";
import KeyIcon from "../../../../components/svg/Key";
import DoneAllIcon from "../../../../components/svg/DoneAll";
import CreditCard from "../../../../components/svg/CreditCard";
import VerifyEmail from "../../../../components/svg/Actions/VerifyEmail";
import EmailValidated from "../../../../components/svg/Actions/EmailValidated";
import VerifyPhone from "../../../../components/svg/Actions/VerifyPhone";
import PhoneValidated from "../../../../components/svg/Actions/PhoneValidated";
import PasswordChanged from "../../../../components/svg/Actions/PasswordChanged";
import AccountValidated from "../../../../components/svg/Actions/AccountValidated";
import Separator from "../../../../components/svg/Separator";
import {useHistory} from "react-router-dom";
import {stripeServices} from "../../../../services/stripeServices";
import StripeConfigComponent from "./StripeConfig";

const VerificationContainer = () => {

    const {t} = useTranslation();
    const query = useQuery();
    const history = useHistory();

    const {user, setUser, loading} = useAuth();

    const [isLoading, setIsLoading] = useState(null);
    const [step, setStep] = useState(1);

    const [phoneNumber, setPhoneNumber] = useState()
    const [country, setCountry] = useState('PT');
    const [dialCode, setDialCode] = useState('+351');

    const {register, control, formState, getValues, errors, setError, setValue, clearErrors} = useForm({mode: "onChange", shouldFocusError: true});

    if(query.token) setValue("token", query.token, {shouldValidate: true, shouldDirty: true})

    //step 1 validate email
    //step 2 email succesfully verified
    //step 3 (optional) change/insert phone number
    //step 4 (optional) change password
    //step 5 configure stripe connect
    //step 6 account verified

    useEffect(()=> {
        if (!user){
            return !loading && history.push("/start/login");
        }
        console.log("user", user)
        if (!user.email_verified) {
            setStep(1);
        } else if (!user.phone) {
            setStep(3)
        } else if (!user.has_password || user.changedTemporaryPassword === false) {
            setStep(4)
        } else if (!user.stripeIsUpdated) {
            setStep(5)
        }
        /* else if(!user.googleId || (!user.has_password && !user.impersonateOriginal && !user.googleId) || (user.hasOwnProperty('changedTemporaryPassword') && !user.changedTemporaryPassword)) {
            setStep(6)
        } */
    }, [user])


    const onSubmit = async () => {
        if (step === 1) {
            setIsLoading("verifyingData");
            let token = getValues().token;
            try {
                if (user && step === 1) {
                    await userServices.verifyEmail(user.email, token);
                }
            } catch (e) {
                console.log(e)
                if(e.error === "invalidToken") {
                    setError("token", {type: "string", message: "invalidToken"})
                }
                if (e.validationErrors) {
                    e.validationErrors.forEach(err => {
                        setError(err.param, {type: "string", message: t("error." + err.msg)});
                    })
                }
                return;
            }
        } else if (step === 2) {
            setStep(user?.phone ? 4 : 3);
            //setShowSuccessPage(false);
            setIsLoading(null);
            return;
        } else if (step === 3) {
            let newPhoneNumber = getValues().phone;
            if(newPhoneNumber) {
                newPhoneNumber = newPhoneNumber.replace(dialCode, "").trim();
                setIsLoading("sendingEmails")
                try {
                    setUser(await userServices.saveAccountDetails({
                        phone: newPhoneNumber,
                        dialCode,
                        language: localStorage.getItem('i18nextLng')?.split('-')[0]||"en"
                    }));
                    if (user.changedTemporaryPassword === false || !user.has_password) return setStep(4)
                }catch(e){
                    if (e.validationErrors) {
                        e.validationErrors.forEach(err => {
                            setError(err.param, {type: "string", message: t("error." + err.msg)});
                        })
                    }
                }
                setIsLoading(null);
                return;
            }
        } else if (step === 4) {
            //change password
            setIsLoading("verifyingData");
            let password = getValues().password;
            try {
                await userServices.changePassword({password});
            } catch (e) {
                if (e.validationErrors) {
                    e.validationErrors.forEach(err => {
                        setError(err.param, {type: "string", message: t("verification." + err.param + ".err-message")});
                    })
                }
            }
        }

        if(!Object.values(errors).length) {
            if ((step === 4 && (user.has_password || user.googleId || user.facebookId) && (user.changedTemporaryPassword || user.changedTemporaryPassword === undefined)) || step === 6) {
                setStep(7);
            } else {
                setStep(prevStep => prevStep + 1)
            }
        }
        setIsLoading(null);
    }

    const resend = async () => {
        setIsLoading("sendingEmails");
        try {
            if (user && step === 1) await userServices.resendVerifyEmail(user.email);
        } catch (e) {
            if (e.validationErrors) {
                e.validationErrors.forEach(err => {
                    setError(err.param, {type: "string", message: t("error." + err.msg)});
                })
            }
            console.log(e);
        }
        setIsLoading(null);
    }

    const illustrationStepContent = [null, VerifyEmail, EmailValidated, VerifyPhone, PasswordChanged, null, AccountValidated];
    const IllustrationComponent = useMemo(() => {
        return illustrationStepContent[step] || null;
    }, [step]);

    const possibleLabels = [null, "email", "emailValidated", "updatePhone", "changePassword", "stripeConnect", "accountValidated"];
    const stepLabel = useMemo(() => {
        return possibleLabels[step] || null;
    }, [step]);

    const continueDisabled = useMemo(() => {
        if (step === 4) return false;
        if (step === 3) {
            return !formState.isDirty || !getValues().phone || errors.phone || isLoading;
        }
        return (!formState.isDirty || formState.isSubmitting || !formState.isValid || isLoading) && step !== 2
    }, [step, formState.isDirty, formState.isValid, formState.isSubmitting, getValues().phone, errors.phone, isLoading]);

    console.log("errors", errors);
    return (
        <div className="verification-container">
            <div className="verification-container__steps">
                <div className="verification-container__steps__icons">
                    <div className={`icon ${step === 1 ? "active" : "validated"}`}><EmailIcon /></div>
                    <Separator />
                    <div className={`icon ${(step === 3) ? "active" : (step > 3) && "validated"}`}><PhoneIcon /></div>
                    <Separator />
                    <div className={`icon ${(step === 4) ? "active" : (step > 4) && "validated"}`}><KeyIcon/></div>
                    <Separator />
                    <div className={`icon ${step === 5 ? "active" : (step === 6 ? "validated" : "")}`}><CreditCard width={24} height={24}/></div>
                    <Separator />
                    <div className={`icon ${step === 6 && "validated"}`}><DoneAllIcon /></div>
                </div>
                <div className={"verification-container__steps__labels" + (step === 5 ? " stripe-step" : "")}>
                    <p className={(step === 1 || step === 2) ? "active" : ""}>{t("verification.steps.email")}</p>
                    <p className={step === 3 ? "active" : ""}>{t("verification.steps.phone")}</p>
                    <p className={step === 4 ? "active" : ""}>{t("verification.steps.password")}</p>
                    <p className={step === 5 ? "active" : ""}>{t("verification.steps.stripe")}</p>
                    <p className={step === 6 ? "active" : ""}>{t("verification.steps.account")}</p>
                </div>
            </div>

            {IllustrationComponent ? <IllustrationComponent /> : null}

            {step !== 7 && <><h3 className="verification-container__title">{stepLabel ? t("verification." + stepLabel + ".title") : null}</h3>
            <p className="verification-container__description">
                <Trans i18nKey={`verification.${stepLabel}.description`}
                       values={{ mail: user?.email, dial: user?.dialCode, number: user?.phone}}
                       components={{ b: <strong /> }} />
            </p></>}

            <form onSubmit={(e) => { e.preventDefault(); onSubmit(); }}>
                <div className={`base-info ${step === 2 && 'none'}`}>
                    <div className="input-container">
                        {step === 1 && <>
                            <label htmlFor={step === 3 ? "phoneInput" : "tokenInput"}>{t("verification." + (step === 3 ? "phoneInput" : "tokenInput"))}</label>
                            <input className={"form-input"} type={"number"} placeholder={t("verification.code")} name={"token"} ref={register({ required: true, minLength: 6, maxLength: 6 })} />
                        </>}
                        {step === 4 && <>
                            <label htmlFor={'password'}>{t("verification.password")}</label>
                            <input className={"form-input"} type={"password"} name={"password"} ref={register({ required: true, minLength: 6, maxLength: 6 })} />
                        </>}
                        {step === 3 && <CountryAndPhoneSelect country={country}
                            setCountry={setCountry}
                            setDialCode={setDialCode} setValue={setValue}
                            control={control}
                            defaultPhone={(user?.dialCode && user?.phone) ? (user?.dialCode + " " + user?.phone) : undefined}
                            phoneNumber={phoneNumber} setPhoneNumber={setPhoneNumber}
                            errors={errors} clearCountryError={() => clearErrors('country')}
                        />}
                        {errors.token?.message && <p className={"error-message"}>{t("verification.invalidCode")}</p>}
                        {errors.password?.message && <p className={"error-message"}>{t("verification.changePassword.err-message")}</p>}
                    </div>
                </div>

                {step !== 5 ? <div className="btn-container">
                    {step === 6 ? <button className="btn btn-primary" onClick={() => { location.href = "/dashboard"; }}>
                        {t("verification.exit")}
                    </button> : <button type={'submit'} className={'btn btn-primary'}
                        disabled={continueDisabled}>
                        {t((step === 1) ? "verification.verify" : step === 6 ? "verification.exit" : "verification.continue")}
                    </button>}
                </div>:
                    <StripeConfigComponent onFinish={async () => {
                        try {
                            await stripeServices.finishAccountOnboarding();
                            setStep(6);
                            setTimeout(() => {
                                setUser(prev => ({...prev, stripeConfiguredAt: new Date(), stripeIsUpdated: true}));
                                location.href = "/dashboard";
                            }, 10000);
                        } catch (e) {
                            console.error("Error on useStripeConnect:", e);
                        }
                    }}/>}

            </form>
            {step === 3 && <div className="verification-container__actions">
                <p>{t("verification.updatePhone.helper")}</p>
            </div>}
            <div className="verification-container__actions">
                {step === 1 && (isLoading === "sendingEmails" ? <p>{t("verification.sendingCode")}</p> : <p>{t("verification.didntReceiveCode")}</p>)}
                <div className={"VerificationContainer-action__btn"}>
                    {(step === 1) && <a type={'button'} className={'blue-link-label'} onClick={resend}>
                        {t('buttons.resend')}
                    </a>}
                </div>
            </div>
        </div>
    )
}


export default VerificationContainer;
